import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BuildingAttachmentsSurface } from './BuildingAttachmentsSurface';
export { BuildingAttachmentsSurface };
/**
 * `BuildingAttachments` -- the composition root, mounted by `react_component` from
 * `buildings/tabs/_attachments.html.erb` when `new_attachment_direct_uploads_enabled?` is true.
 * `BuildingAttachmentsSurface` configures the shared `@features/Attachments` surface; this
 * wrapper's own job is only the `QueryClientProvider` every mounted island owns for itself
 * (mirrors `CustomerFileDrop`'s own entry component).
 */
function BuildingAttachments(props) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(BuildingAttachmentsSurface, Object.assign({}, props))));
}
export default BuildingAttachments;
